import React, { useState } from "react";
import Container from "../../../components/Layout/Container";
import { QueryClient, QueryClientProvider } from "react-query";
import Feeds from "./components/Feeds";
import AdditionalSettings from "./components/AdditionalSettings";

export const queryClient = new QueryClient();
export default function XMLFeedGenerationPage({ match }) {
    const [tabId, setTabId] = useState("feeds");

    const breadcrumbLabels = {
        feeds: "Feeds",
        additionalSettings: "Additional Settings",
    };

    const breadcrumbs = [
        { label: "Bigbox", value: "/marketing" },
        {
            label: breadcrumbLabels[tabId],
            value: `/marketing/features/${tabId}`,
        },
    ];

    return (
        <Container
            location={{
                locationName: breadcrumbLabels[tabId],
                locationUrl: match.url,
            }}
            breadcrumbs={breadcrumbs}
        >
            <QueryClientProvider client={queryClient}>
                {tabId === "feeds" && (
                    <Feeds key={tabId} tabId={tabId} setTabId={setTabId} />
                )}
                {tabId === "additionalSettings" && (
                    <AdditionalSettings key={tabId} tabId={tabId} setTabId={setTabId} />
                )}
            </QueryClientProvider>
        </Container>
    );
}
